module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_troendelag_neg.1dc5ce72.svg";